import { render, staticRenderFns } from "./PassportSNP.vue?vue&type=template&id=6c66b29c&scoped=true&"
import script from "./PassportSNP.vue?vue&type=script&lang=js&"
export * from "./PassportSNP.vue?vue&type=script&lang=js&"
import style0 from "./PassportSNP.vue?vue&type=style&index=0&id=6c66b29c&lang=scss&scoped=true&"
import style1 from "./PassportSNP.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66b29c",
  null
  
)

export default component.exports